export default {
  validator: {
    code: 'Mã',
    priceCode: 'Mã giá',
    priceType: 'Loại giá'
  }
}
